import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/css/styles.scss';

// Set initial theme based on system preference
const setInitialTheme = () => {
    // Check if we have a saved preference in localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
        document.documentElement.setAttribute('data-theme', savedTheme);
        return;
    }

    document.documentElement.setAttribute('data-theme', 'dark');

};

// Set initial theme before rendering
setInitialTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);